import { render, staticRenderFns } from "./BreweryList.vue?vue&type=template&id=05866580&scoped=true&lang=pug&"
import script from "./BreweryList.vue?vue&type=script&lang=js&"
export * from "./BreweryList.vue?vue&type=script&lang=js&"
import style0 from "./BreweryList.vue?vue&type=style&index=0&id=05866580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05866580",
  null
  
)

export default component.exports